// LocationArea.js
import {
  defineComponent,
  inject,
  computed,
} from "/Scripts/vue.esm-browser.js";
import { getTextWithoutSign } from "/Scripts/tools.js";
import ThemeWrap from "/Component/Shop/product/ThemeWrap.js";
const html = String.raw;
export default defineComponent({
  name: "LocationArea",
  components: {
    ThemeWrap,
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
    isFilterOpen: {
      type: Boolean,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  inject: ["groupShowType"],
  emits: [],
  setup(props, { emit }) {
    const allProductPopup = inject("allProductPopup");
    const allProductBaseData = inject("allProductBaseData");
    const nowPage = inject("nowPage");

    //判斷是否沒產品(例如篩選條件太嚴苛)
    const hasProduct = computed(() => {
      let hasGroups = false;
      props.item.items.forEach((item) => {
        if (item.groups.length > 0) {
          hasGroups = true;
        }
      });

      return hasGroups;
    });
    return {
      allProductPopup,
      allProductBaseData,
      nowPage,
      hasProduct,
    };
  },
  template: html`
    <div
      class="location_area"
      :data-location-name="getTextWithoutSign(item.subArea)"
    >
      <!-- 地點大標  -->
      <div
        class="location_title"
        :class="{ 'alldepart_date': groupShowType === 'uni' }"
      >
        {{item.subArea}}
        <p @click="openAllProductPopup(item)" v-if="hasProduct">
          <span>{{getTextWithoutSign(item.subArea)}}</span>
          所有出發日期
          <i class="fa-solid fa-chevron-right"></i>
        </p>
      </div>

      <!-- 依主題為區塊  -->
      <theme-wrap
        v-for="item in item.otherAreas"
        :key="item.otherArea"
        :item="item"
        :isFilterOpen="isFilterOpen"
        :loading="loading"
      ></theme-wrap>
    </div>
  `,
  methods: {
    getTextWithoutSign(text) {
      return getTextWithoutSign(text);
    },
    openAllProductPopup(data) {
      this.allProductPopup = true;
      this.allProductBaseData = {
        data: data.items,
        subArea: data.subArea,
        type: "subArea",
      };
      this.nowPage = 1;
    },
  },
});
